module.exports = __webpack_public_path__ + "static/coffee-117a7092824f6068577b12eb973d411f.jpg";